import $ from 'jquery';

export default {
  init() {
  },
  finalize() {
    // SubVideoNav.init();
    TopCategoryToggle.init();
  },
};

var TopCategoryToggle = ( () =>  {
  var self = {};

  var $buttons = $('button.top-category-toggle');

  self.init = () => {
    $buttons.click(self.selectTopCategory);
  };

  self.selectTopCategory = (e) => {
    top.location = $(e.target).data('href');
  };

  return self;
})();

var SubVideoNav = ( () =>  {
  var self = {};
  const desktop_bp = 960;

  const $trigger = $("div.class--filter, .sub-nav a.close"),
        $menu = $('.sub-nav ul');

  self.init = () => {
   $trigger.on('click', self.toggleNav);
   window.addEventListener('resize', _.throttle(self.resetNav, 400) );
   window.addEventListener('scroll', _.throttle(self.resetNav, 100) );
  };

  self.closeNav = () => {
    $menu.removeClass('open');
    $menu.hide();
  }

  self.resetNav = () => {
    var windowWidth = $(window).width();
    if( windowWidth < desktop_bp) {
      self.closeNav();
    }
    else if( windowWidth >= desktop_bp) {
      $menu.show();
    }
  }

  self.toggleNav = (e) => {
    if($(window).width() >= desktop_bp) {
      return;
    }
    if(e) {
      e.stopPropagation();
    }
    if( $menu.hasClass('open') ) {
      $menu.fadeOut();
    }
    else {
      $menu.fadeIn();
    }
    $menu.toggleClass('open');
    return false;
  };

  return self;
})();